/* eslint-disable no-use-before-define */

const relations = [
  'image',
  'images',
  'videos',
  'deliveryPackages',
  'accessories',
  'leases', // vehiclelease
  'externalLeases', // external lease
  'privateLease', // private lease
  'vdp', // f.e. on externalLeases
  'spincar',
  'vehicle', // f.e. on form submissions
  'company', // f.e. on vehicles
  'mainContact', // on company
  'overlay', // on vehicle images
];

const mapRelation = (content) => {
  // in v5 the parent is the array
  if (Array.isArray(content)) {
    return content.map(({ data }) => mapApolloData(data));
  }
  // in v4 the data is the array
  if (Array.isArray(content.data)) {
    return content.data.map((child) => mapApolloData(child));
  }
  // v4 will have data around relations
  if (content.data) {
    return mapApolloData(content.data);
  }

  return content;
};

const mapApolloData = (obj) => {
  if (!obj) {
    return undefined;
  }
  const {
    id,
    documentId,
    attributes = {},
  } = obj;

  const res = relations.reduce((acc, key) => {
    const related = attributes[key];
    if (!related) {
      return acc;
    }
    const resolved = mapRelation(related);
    return {
      ...acc,
      [key]: resolved,
    };
  }, {
    id,
    strapiId: id,
    documentId,
    ...attributes,
  });

  return res;
};

export default mapApolloData;
